/**
 * Quotation document viewer — a thin wrapper over the shared DocumentPrintPage
 * with the quotation configuration.
 */
import { QUOTATION_DOC_CONFIG } from './docPrintConfigs.js';
import { DocumentPrintPage } from './DocumentPrintPage.js';

export function QuotationPrintPage(): JSX.Element {
  return <DocumentPrintPage config={QUOTATION_DOC_CONFIG} />;
}
